module.exports = __webpack_public_path__ + "static/media/IMG_0340.d8f9dce4.JPG";